import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgDoubleSupport = ({ title, titleId, ...props }, ref) => /* @__PURE__ */ _jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	width: 71.955,
	height: 33.802,
	viewBox: "0 0 71.955 33.802",
	ref,
	"aria-labelledby": titleId,
	...props,
	children: [title ? /* @__PURE__ */ _jsx("title", {
		id: titleId,
		children: title
	}) : null, /* @__PURE__ */ _jsxs("g", {
		id: "Group_195",
		"data-name": "Group 195",
		transform: "translate(0)",
		children: [
			/* @__PURE__ */ _jsx("g", {
				id: "Group_188",
				"data-name": "Group 188",
				transform: "translate(0 0)",
				opacity: 0,
				children: /* @__PURE__ */ _jsx("path", {
					id: "Path_388",
					"data-name": "Path 388",
					d: "M1348.48,198.217h-71.955v-33.8h71.955Zm-71.435-.52h70.915V164.935h-70.915Z",
					transform: "translate(-1276.526 -164.415)",
					fill: "#040505"
				})
			}),
			/* @__PURE__ */ _jsx("g", {
				id: "Group_189",
				"data-name": "Group 189",
				transform: "translate(12.2 15.22)",
				children: /* @__PURE__ */ _jsx("path", {
					id: "Path_389",
					"data-name": "Path 389",
					d: "M1300,193.7",
					transform: "translate(-1300 -193.7)",
					fill: "none",
					stroke: "#040505",
					strokeLinecap: "round",
					strokeLinejoin: "round",
					strokeWidth: 4
				})
			}),
			/* @__PURE__ */ _jsxs("g", {
				id: "Group_194",
				"data-name": "Group 194",
				transform: "translate(7.136 4.403)",
				children: [
					/* @__PURE__ */ _jsx("path", {
						id: "Path_390",
						"data-name": "Path 390",
						d: "M1315.555,189.931c-.363-.132-.782-.278-1.229-.433a22.621,22.621,0,0,1-4.856-2.062c-.861-.719-2.868-2.766-5.505-5.616a1.239,1.239,0,0,0-.633-.362c.034-.242.077-.5.142-.774.3-1.254.921-3.792,1.269-5.206a1.039,1.039,0,0,0-.759-1.258h0a1.039,1.039,0,0,0-1.259.76c-.35,1.418-.977,3.967-1.273,5.226a9.3,9.3,0,0,0-.238,3.091l-.071.091a3.277,3.277,0,0,1-1.965-.215,4.258,4.258,0,0,1-1.285-1.174h0c-.028-.036-.063-.064-.094-.1.151-.347.328-.793.559-1.374A30.113,30.113,0,0,0,1299.5,174a1.04,1.04,0,0,0-2.074-.151,27.609,27.609,0,0,1-1,5.908c-.3.757-.485,1.191-.594,1.436a2.081,2.081,0,0,0-1.172.639,10.266,10.266,0,0,0-1.168,1.565,18.841,18.841,0,0,0-1.609,3.215,6.19,6.19,0,0,0-1.455,1.821,1.037,1.037,0,0,0-.09.969,6.465,6.465,0,0,0,4.1,3.237c2.766.925,11.955,2.991,12.39,3.088a20.806,20.806,0,0,0,3.327.272,10.645,10.645,0,0,0,4.466-.809c1.6-.776,2.519-1.994,2.454-3.257A2.243,2.243,0,0,0,1315.555,189.931Zm-1.843,3.39c-1.88.912-5.346.57-6.476.37-.094-.021-9.475-2.13-12.142-3.021a5.38,5.38,0,0,1-2.558-1.641c.2-.282.388-.541.5-.668l.141-.068a1.044,1.044,0,0,0,.541-.628,15.625,15.625,0,0,1,1.544-3.17,7.182,7.182,0,0,1,.952-1.256c.015,0,.02.006.021.009a6.165,6.165,0,0,0,1.954,1.751,5.685,5.685,0,0,0,4.071.263,1.041,1.041,0,0,0,.663-.636c.073-.2.161-.414.25-.609,1.619,1.734,3.877,4.1,4.969,5.014.984.822,2.989,1.556,5.506,2.43.437.152.846.294,1.2.423.146.053.15.118.152.157C1315.009,192.3,1314.678,192.853,1313.712,193.321Z",
						transform: "translate(-1290.256 -172.887)",
						fill: "#040505"
					}),
					/* @__PURE__ */ _jsx("path", {
						id: "Path_391",
						"data-name": "Path 391",
						d: "M1374.009,191.741a2.241,2.241,0,0,0-1.931-1.607c-.385-.047-.826-.094-1.3-.143a22.56,22.56,0,0,1-5.2-.908c-1.429-.72-5.116-3.193-6.636-4.223a1.233,1.233,0,0,0-.7-.209c-.022-.243-.039-.5-.037-.786.006-1.819.07-6.351.071-6.4a1.04,1.04,0,0,0-2.079-.03c0,.046-.064,4.589-.071,6.419a9.317,9.317,0,0,0,.467,3.06c-.006.034-.013.064-.019.1a3.322,3.322,0,0,1-1.991.247,4.262,4.262,0,0,1-1.517-.853h0c-.035-.029-.076-.048-.113-.075.068-.373.14-.846.233-1.465a30.011,30.011,0,0,0-.364-6.613,1.039,1.039,0,1,0-2.053.322,27.606,27.606,0,0,1,.362,5.981c-.122.806-.2,1.27-.253,1.534a2.1,2.1,0,0,0-1,.888,10.428,10.428,0,0,0-.783,1.789,18.842,18.842,0,0,0-.838,3.5,6.2,6.2,0,0,0-1,2.1,1.038,1.038,0,0,0,.132.965,6.465,6.465,0,0,0,4.726,2.223c1.888.178,6.534.21,9.673.21,1.686,0,2.938-.009,3.094-.011.2-.01,4.984-.28,7.47-2.289C1373.741,194.35,1374.359,192.956,1374.009,191.741Zm-22.772-5.844c-.023.015-.043.032-.064.048C1351.194,185.929,1351.213,185.912,1351.237,185.9Zm-.157.122-.017.018,0,0Zm19.971,7.833c-1.625,1.314-5.078,1.766-6.225,1.828-.1,0-9.712.072-12.51-.192a5.383,5.383,0,0,1-2.864-1.019c.133-.332.259-.62.334-.764l.12-.1a1.044,1.044,0,0,0,.385-.735,15.606,15.606,0,0,1,.784-3.436,7.266,7.266,0,0,1,.643-1.44.025.025,0,0,1,.023,0,6.167,6.167,0,0,0,2.3,1.263,5.694,5.694,0,0,0,4.025-.666,1.041,1.041,0,0,0,.5-.769c.026-.213.063-.44.106-.651,1.968,1.322,4.7,3.116,5.976,3.758,1.145.577,3.263.838,5.912,1.119.46.048.892.094,1.267.14.154.018.172.081.183.118C1372.083,192.563,1371.886,193.177,1371.051,193.852Z",
						transform: "translate(-1317.606 -174.581)",
						fill: "#040505"
					}),
					/* @__PURE__ */ _jsxs("g", {
						id: "Group_193",
						"data-name": "Group 193",
						transform: "translate(1.554 22.814)",
						children: [
							/* @__PURE__ */ _jsx("g", {
								id: "Group_190",
								"data-name": "Group 190",
								transform: "translate(50.932)",
								children: /* @__PURE__ */ _jsx("path", {
									id: "Path_392",
									"data-name": "Path 392",
									d: "M1395.4,218.864h-3.118a1.039,1.039,0,1,1,0-2.079h3.118a1.039,1.039,0,1,1,0,2.079Z",
									transform: "translate(-1391.247 -216.785)",
									fill: "#040505"
								})
							}),
							/* @__PURE__ */ _jsx("g", {
								id: "Group_191",
								"data-name": "Group 191",
								transform: "translate(9.949)",
								children: /* @__PURE__ */ _jsx("path", {
									id: "Path_393",
									"data-name": "Path 393",
									d: "M1347.583,218.864h-6.83a1.039,1.039,0,1,1,0-2.079h6.83a1.039,1.039,0,0,1,0,2.079Zm-13.661,0h-6.83a1.039,1.039,0,1,1,0-2.079h6.83a1.039,1.039,0,1,1,0,2.079Zm-13.661,0h-6.83a1.039,1.039,0,1,1,0-2.079h6.83a1.039,1.039,0,1,1,0,2.079Z",
									transform: "translate(-1312.391 -216.785)",
									fill: "#040505"
								})
							}),
							/* @__PURE__ */ _jsx("g", {
								id: "Group_192",
								"data-name": "Group 192",
								children: /* @__PURE__ */ _jsx("path", {
									id: "Path_394",
									"data-name": "Path 394",
									d: "M1297.4,218.864h-3.118a1.039,1.039,0,0,1,0-2.079h3.118a1.039,1.039,0,0,1,0,2.079Z",
									transform: "translate(-1293.247 -216.785)",
									fill: "#040505"
								})
							})
						]
					})
				]
			})
		]
	})]
});
const ForwardRef = forwardRef(SvgDoubleSupport);
export { ForwardRef as ReactComponent };
